var _path, _path2, _ellipse;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoadViewIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7923 5.95597C11.7923 9.00001 8.01378 13.3193 5.97918 13.3193C3.94457 13.3193 0.166016 8.69859 0.166016 5.65455C0.166016 2.46808 2.98269 0.142822 5.97918 0.142822C8.97566 0.142822 11.7923 2.46808 11.7923 5.95597Z",
    fill: "#0C002C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.748047 15.5615C0.748047 15.2405 1.00831 14.9802 1.32936 14.9802H10.6304C10.9515 14.9802 11.2117 15.2405 11.2117 15.5615C11.2117 15.8826 10.9515 16.1428 10.6304 16.1428H1.32936C1.00831 16.1428 0.748047 15.8826 0.748047 15.5615Z",
    fill: "#0C002C"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.88776,
    cy: 5.39294,
    rx: 2.32526,
    ry: 2.32824,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadViewIcon);
export default __webpack_public_path__ + "static/media/roadViewIcon.4d29fc800bc88ab0999def704604a551.svg";
export { ForwardRef as ReactComponent };